module.exports = __webpack_public_path__ + "static/img/96035A_X_06_20170509_256_LC.4d3b85b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96035A_X_06_20170509_256_LC.png
// module id = o+xD
// module chunks = 0